import fetcher from 'helpers/fetcher';

export default {
	voucher (chid, form) {
		return fetcher.post(`private/payment/${chid}/deposit-voucher`, {}, { params: form });
	},
};
